import {ApiError} from "./types";

export default class CouldNotStartTimerError extends ApiError {
    public team: string;

    constructor(json: any, team: string) {
        super(json.errorCode, json.message);
        this.team = team;
    }
}



// WEBPACK FOOTER //
// ./src/api/errors/CouldNotStartTimerError.ts